import Konva from 'konva';
import { Group, Line, Rect, Text } from 'react-konva';
import { GraphStyle } from '../types';
import LayoutList from './layout/LayoutList';



function Tooltip({
	title,
	labels,
	style,
	...props
}: TooltipProps) {

	if (!labels || labels.length == 0 || props.x < 0) return null

	const { padding, margin, title: titleStyle, label } = style.tooltip

	const position = {
		x: props.x + margin.left,
		y: props.y - style.space.y - padding.top + margin.top
	}
	const bgProps = {
		width: padding.left + padding.right + style.tooltip.width,
		height: padding.top + padding.bottom + ((labels.length + (title ? 1 : 0)) * style.space.y),
		y: title ? 0 : style.space.y,
		fill: style.tooltip.bg.color
	}
	const listProps = {
		space: style.space.y,
		margin: 0,
		y: style.space.y + padding.top,
	}
	const porpsLine = {
		points: [0, style.space.y, bgProps.width - padding.right, style.space.y],
		stroke: style.tooltip.line.color,
		strokeWidth: 1
	}
	const porpsLineTitle = {
		...porpsLine,
		points: [0, style.space.y, bgProps.width, style.space.y]
	}
	const propsLabel = {
		x: padding.left,
		fontSize: label.size,
		fill: label.color,
		verticalAlign: "middle", align: "right",
		width: bgProps.width - padding.left - padding.right,
		height: style.space.y,
	}
	const propsTitle = {
		fontSize: titleStyle.size,
		fill: titleStyle.color,
		verticalAlign: "middle", align: "center",
		width: bgProps.width,
		height: style.space.y,
		text: title,
	}

	return (
		<Group {...props} {...position}>
			<Rect {...bgProps}
				stroke="#000000"
				strokeWidth={1}
				cornerRadius={[0, 3, 3, 0]}
				shadowBlur={4}
				shadowOffsetX={2}
				shadowOffsetY={1}
				shadowOpacity={0.4}
			/>

			{/* TITLE */}
			{title && <Group y={padding.top}>
				<Text {...propsTitle} fontStyle="bold" />
				<Line {...porpsLineTitle} />
			</Group>}

			<LayoutList {...listProps}>
				{labels.map((label, index) => (
					<Group key={index}>
						<Text {...propsLabel} text={label} />
						<Line {...porpsLine} />
					</Group>
				))}
			</LayoutList>

		</Group>

	);
}

export default Tooltip

type TooltipProps = {
	title: string,
	labels: string[],
	style: GraphStyle,
} & Konva.NodeConfig
